import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";

const BLOG_API =
  "https://script.google.com/macros/s/AKfycbwmB7z0yq-ZZ0XACM5xUanfOu8inX0RSQ9DBbDqZuwftlDeoXbaphtqFg2VgdB7tqnr/exec?type=blogs";

function BlogPost() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetch(BLOG_API)
      .then((res) => res.json())
      .then((data) => {
        const found = (data.blogs || []).find((b) => b.slug === slug);
        setBlog(found);
      });
  }, [slug]);

  if (!blog) return <p>Loading blog…</p>;

  return (
    <article className="section blog-post">
      <nav className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <Link to="/blog">Blog</Link>
      </nav>
      <h1>{blog.title}</h1>
      <p className="blog-meta">
        {blog.author} · {blog.publishedDate}
      </p>

      <img src={blog.coverImageUrl} alt={blog.title} className="blog-cover" />

      <div
        className="blog-content"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />
    </article>
  );
}

export default BlogPost;
